<script>
	import { fly } from "svelte/transition";
	import { quadInOut } from "svelte/easing";
	import { createEventDispatcher } from "svelte";

	const dispatch = createEventDispatcher();

	const toggle = () => dispatch("toggle");

	const animationSettings = {
		y: 200,
		duration: 200,
		easing: quadInOut,
	};
</script>

<div class="overlay" transition:fly={animationSettings} on:click={toggle} />
<div class="modelComparison" transition:fly={animationSettings}>
	<h1>Model Comparison</h1>
	<div class="models">
		<div class="modelOuter">
			<h2>Iconic</h2>
			<div class="model">
				<p>Starting <strong>RRP €30,340</strong></p>
				<ul>
					<li>17" Alloy Wheels</li>
					<li>Automatic Climate Control</li>
					<li>Multimedia system with DAB radio on 7" touch screen</li>
					<li>Handsfree Key Card</li>
				</ul>
			</div>
		</div>

		<div class="modelOuter">
			<h2>S-Edition</h2>
			<div class="model">
				<p>Starting <strong>RRP €32,540</strong></p>
				<ul>
					<li>18" Diamond Cut Alloy Wheels</li>
					<li>Cruise Control</li>
					<li>Automatic High/Low Beam</li>
					<li>Rear Cross Traffic Alert</li>
				</ul>
			</div>
		</div>

		<div class="modelOuter">
			<h2>RS Line</h2>
			<div class="model">
				<p>Starting <strong>RRP €35,140</strong></p>

				<ul>
					<li>Front and Rear Parking Sensors with Intelligent Park Assist</li>
					<li>Heated Seats</li>
					<li>F1 Blade and Honeycomb Lower Grille</li>
				</ul>
			</div>
		</div>
	</div>

	<a class="button" target="_blank" href="http://www.renault.ie/cars/arkana">
		Visit site
	</a>

	<div class="close" on:click={toggle}>⨯</div>
</div>

<style>
	.modelComparison {
		width: 80%;
		z-index: 9999;
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		left: 10%;
		font-size: 14px;
		text-align: left;
		background: white;
		text-align: center;
		padding: 0 1rem;
	}
	@media (max-width: 500px) {
		.modelComparison {
			width: 100%;
			left: 0%;
		}
	}
	h1 {
		text-transform: uppercase;
		font-size: 16px;
		font-weight: normal;
		margin: 1.5em 0;
	}
	h2 {
		text-align: center;
		text-transform: uppercase;
		font-size: 18px;
	}
	.overlay {
		z-index: 9999;
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.5);
		padding: 0 1rem;
	}
	.models {
		text-align: left;
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 1rem;
		margin: 1rem 0;
	}
	.model {
		position: relative;
	}
	.model:after {
		content: "";
		display: block;
		width: 1px;
		height: 100%;
		background: #ddd;
		position: absolute;
		bottom: 0;
		right: -0.5em;
	}
	.modelOuter:last-of-type .model:after {
		display: none;
	}
	p {
		padding: 0.5em 0;
	}
	ul {
		padding: 0;
		list-style: none;
	}
	li {
		padding: 0.25em 0;
	}
	.close {
		font-size: 30px;
		position: absolute;
		width: 1em;
		text-align: center;
		height: 1em;
		line-height: 0.75em;
		top: -0.5em;
		right: -0.5em;
		cursor: pointer;
		z-index: 9999;
		color: white;
		background: black;
		border-radius: 50%;
		animation: reveal ease-out 0.2s;
		animation-delay: 0.5s;
		animation-fill-mode: backwards;
	}
	@media (max-width: 500px) {
		.close {
			font-size: 20px;
			top: 1em;
			right: 0.5em;
		}
	}
	@keyframes reveal {
		0% {
			opacity: 0;
			transform: scale(0) rotate(2turn);
		}
		100% {
			opacity: 1;
			transform: scale(1) rotate(0deg);
		}
	}
</style>
